import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import VueMeta from 'vue-meta'
import NProgress from 'nprogress'
import moment from 'moment'

import WebsiteNavbarContainer from '../components/website/NavbarContainer.vue'
import EmployerNavbarContainer3 from '../components/website/employer3/EmployerNavbarContainer3.vue';
import JobseekerNavbarContainer3 from '../components/website/jobseekers3/JobseekerNavbarContainer3.vue';
import AdminNavbarContainer from '../components/NavbarContainer.vue'
import JobseekerRoute3 from './jobseekers3.js'
import EmployerRoute3 from './employer3.js'
import { WebsiteRoute } from './website'
import AdminRoute from './admin';

import EluckyDraw from '../components/Jobseeker/ELucky_Draw/Landing.vue'
import EluckyDrawSelection from '../components/Jobseeker/ELucky_Draw/CardSelection.vue'
import EluckyDrawResult from '../components/Jobseeker/ELucky_Draw/Result.vue'
import ensureGoogleMaps from '../utils/googleMaps'
import ensureViewer from '../utils/viewer'

Vue.use(VueMeta);

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/v2/jobseeker/elucky-draw',
      name: 'elucky-draw',
      route: 'elucky-draw',
      component: EluckyDraw,
      meta: { requiresAuth: false, hideForAuth: false}
    },
    {
      path: '/v2/jobseeker/elucky-draw-selection/:id',
      name: 'elucky-draw-selection',
      route: 'elucky-draw-selection',
      component: EluckyDrawSelection,
      meta: { requiresAuth: false, hideForAuth: false}
    },
    {
      path: '/v2/jobseeker/elucky-draw-result/:id/:amount',
      name: 'elucky-draw-result',
      route: 'elucky-draw-result',
      component: EluckyDrawResult,
      meta: { requiresAuth: false, hideForAuth: false}
    },
    /** Make HomeNew.vue as a default page */
    {
      path: '/',
      component: WebsiteNavbarContainer, 
      children: WebsiteRoute,           
      meta: { requiresAuth: false, hideForAuth: true },
    },
    {
      path: '/singapore-jobs',
      component: WebsiteNavbarContainer,
      children: WebsiteRoute,
      meta: { requiresAuth: false, hideForAuth: true }
    },
    // {
    //   path: '/admin-login',
    //   component:  v1AdminLogin,
    //   name: 'v1AdminLogin',
    //   meta: { requiresAuth: false, hideForAuth: true }
    // },
    {
      path: '/employer',

      component: EmployerNavbarContainer3,
      children: EmployerRoute3,
      meta: { requiresAuth: false, hideForAuth: true, isEmployer: true }
    },
    {
      // path: '/',
      path: '/jobseeker',
      component: JobseekerNavbarContainer3,
      children: JobseekerRoute3,
      meta: { requiresAuth: false, hideForAuth: true }
    },
    {
      path: '/v2/*',
      name: 'Home',
      component: AdminNavbarContainer,
      children: AdminRoute,
      meta: { requiresAuth: false, hideForAuth: true }
    },
    // Legacy/orphan slugs that Google still has indexed. Without an entry here they fall through
    // to the `*` catch-all → /error-404, which nginx serves as a 200 SPA shell — a soft 404 that
    // keeps burning crawl budget (AJ-6: /job-listing was indexed as "Page Not Found"). Redirecting
    // them to the live jobs hub turns them into a "Page with redirect" in GSC instead. The true
    // fix is an nginx `return 301` (see seo_ops_setup.md); this covers it until that is applied,
    // and stays harmless afterwards because nginx answers first.
    {
      path: '/job-listing',
      redirect: '/singapore-jobs',
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ]
})

// Route names whose components render an interactive <GmapMap>/<gmap-autocomplete>/<GmapCluster>.
// The guard below lazy-installs vue2-google-maps for these (and ONLY these) routes, so public pages
// never load the maps wrapper. If you add a new Daily-Paid/admin map route, add its `name` here.
const MAP_ROUTE_NAMES = new Set([
  'allDailyPaidJobDetail', 'heat-map-list', 'jobseeker-dp-profile-view', 'repostJobDaily',
  'dailyJobDetail', 'DailyJobPost', 'DailyJobPostAdmin', 'DailyJobEdit', 'DailyJobManage',
  'dp-jobs-post', 'dp-jobs', 'dp-jobs-multiple', 'dp-jobs-repost', 'dp-jobs-edit',
]);

router.beforeEach(async (to, _, next) => {
  // Install the Google Maps wrapper before rendering an interactive-map route (so <GmapMap> etc.
  // are registered by render time). Non-map routes skip this entirely. Failure is non-fatal.
  if (MAP_ROUTE_NAMES.has(to.name)) {
    try { await ensureGoogleMaps(); } catch (e) { /* page still renders without the map */ }
  }
  // v-viewer (image lightbox) is used only on authenticated pages — install it once the user is logged
  // in (its <viewer> component + directive must be registered before render). isAuthenticated is
  // token-based (!!JwtService.getToken()). Logged-out/public pages never load viewerjs. Non-fatal.
  if (store.getters.isAuthenticated) {
    try { await ensureViewer(); } catch (e) { /* page still renders without the image viewer */ }
  }
  if (to.name) {
    NProgress.start();
  }

  // var last = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);

  // if(last == 'jobseekers'){
  //   window.location.replace('/');
  // }

  // console.log(!to.meta.requiresAuth,store.getters.isAuthenticated,store.getters.getUserLoggedInPanel, to.name,store.getters.currentUser,'currentUser')
  if (!to.meta.requiresAuth) {

    console.log(store.getters.isAuthenticated, !to.meta.requiresAuth, store.getters.getUserLoggedInPanel, to.name)

    if (store.getters.isAuthenticated && !to.meta.requiresAuth && store.getters.getUserLoggedInPanel == 'jobseeker' && to.name == 'jobseekers3') {
      window.location.replace('/v2/jobseeker/daily-job-profile');
    }
    if (store.getters.isAuthenticated && !to.meta.requiresAuth && store.getters.getUserLoggedInPanel == 'admin' && to.name == 'jobseekers3') {
      window.location.replace('/v2/admin/jobseekers');
    }
    if (store.getters.isAuthenticated && !to.meta.requiresAuth && store.getters.getUserLoggedInPanel == 'employer' && store.getters.currentUser.is_company_head == 'yes' && store.getters.currentUser.user_type_id == '3' && to.name == 'jobseekers3') {
      window.location.replace('/v2/employer/dp-job-manage');
    }
    if (store.getters.isAuthenticated && !to.meta.requiresAuth && store.getters.getUserLoggedInPanel == 'employer' && store.getters.currentUser.is_company_head == 'no' && to.name == 'jobseekers3') {
      window.location.replace('/v2/employer/om-supervisor-profile');
    }
    if (store.getters.isAuthenticated && !to.meta.requiresAuth && store.getters.getUserLoggedInPanel == 'jobseeker' && to.name == 'allJobsListing') {
      window.location.replace('/v2/jobseeker/joblist');
    }
    if (store.getters.isAuthenticated && !to.meta.requiresAuth && store.getters.getUserLoggedInPanel == 'jobseeker' && to.name == 'allDailyPaidJoblisting') {
      window.location.replace('/v2/jobseeker/daily-joblist');
    }
    if (store.getters.isAuthenticated && !to.meta.requiresAuth && store.getters.getUserLoggedInPanel == 'admin' && to.name == 'adminlogin') {
      next('/v2/admin/jobseekers');
    } else {
      return next();
    }

  } else {
    if (to.meta.requiresAuth && !store.getters.isAuthenticated) {
      if(to.path.includes('/employer/')){
        next('/login-employer');
      }else{
        next('/login-jobseeker');
      }
    } else if (store.getters.isAuthenticated && !to.meta.requiresAuth && store.getters.getUserLoggedInPanel == 'admin') {
      if(store.getters.currentUser.designation && store.getters.currentUser.designation == 'External Agent'){
        window.location.replace('/v2/admin/daily-deployment');
      }else{
        next('/v2/admin/jobseekers');
      }
      
    } else if (store.getters.isAuthenticated && !to.meta.requiresAuth && store.getters.getUserLoggedInPanel == 'employer') {
      if(store.getters.currentUser.designation && store.getters.currentUser.designation == 'External Agent'){
        window.location.replace('/v2/admin/daily-deployment');
      }else{
        next('/v2/admin/jobseekers');
      }
    } else if (store.getters.isAuthenticated && !to.meta.requiresAuth && store.getters.getUserLoggedInPanel == 'jobseeker') {
      if(store.getters.currentUser.designation && store.getters.currentUser.designation == 'External Agent'){
        window.location.replace('/v2/admin/daily-deployment');
      }else{
        next('/v2/admin/jobseekers');
      }
    } else if (store.getters.isAuthenticated && store.getters.getUserLoggedInPanel == 'employer' && to.meta.showFor != 'employer' && to.meta.showFor != '') {
      if ((store.getters.currentUser.user_type_id == 3 || store.getters.currentUser.user_type_id == 4) && store.getters.currentUser.is_company_head == 'no') {
        if (store.getters.currentUser.account_verification_status == 'completed') {
          window.location.replace('/v2/employer/dp-job-manage');
        } else if (store.getters.currentUser.ft_account_status == 'completed') {
          window.location.replace('/v2/employer/manage-jobs');
        } else {
          window.location.replace('/v2/employer/om-supervisor-profile');
        }
      } else {
        if (store.getters.currentUser.account_verification_status == 'completed') {
          window.location.replace('/v2/employer/dp-job-manage');
        } else if (store.getters.currentUser.ft_account_status == 'completed') {
          window.location.replace('/v2/employer/manage-jobs');
        } else {
          window.location.replace('/v2/employer/employer-profile');
        }
      }

      // next('/v2/employer/dashboard');
    } else if (store.getters.isAuthenticated && store.getters.getUserLoggedInPanel == 'jobseeker' && to.meta.showFor != 'jobseeker' && to.meta.showFor != '') {
      // next('/jobseeker/dashboard');
      window.location.replace('/v2/jobseeker/daily-job-profile');

    } else if (store.getters.isAuthenticated && store.getters.getUserLoggedInPanel == 'admin' && to.meta.showFor != 'admin' && to.meta.showFor != '') {
      if(store.getters.currentUser.designation && store.getters.currentUser.designation == 'External Agent'){
        window.location.replace('/v2/admin/daily-deployment');
      }else{
        window.location.replace('/v2/admin/jobseekers');
      }
     
      // next('/admin/dashboard');
      
      //window.location.replace('/v2/jobseeker/jobseeker-profile');

    } else if (store.getters.isAuthenticated && store.getters.getUserLoggedInPanel == 'admin' && to.meta.showFor != 'admin' && to.meta.showFor != '') {
      if(store.getters.currentUser.designation && store.getters.currentUser.designation == 'External Agent'){
        window.location.replace('/v2/admin/daily-deployment');
      }else{
        window.location.replace('/v2/admin/jobseekers');
      }
    }
    else {
      // console.log(window.location,'window.location',window.location.pathname != '/v2/admin/daily-deployment')
      
      if(store.getters.currentUser.designation && store.getters.currentUser.designation == 'External Agent'){
        if(window.location.pathname != '/v2/admin/daily-deployment'){
          window.location.replace('/v2/admin/daily-deployment');
        }else{
          return next();
        }
      }else{
       return next();
      }
      
    }
  }

})


router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  NProgress.done();

  // Re-assert English as the global moment locale after every navigation. The DP job-posting
  // pickers (vue-persian-datetime-picker → moment-jalaali's loadPersian) call
  // moment.updateLocale('fa', …), and moment's updateLocale flips the GLOBAL locale to Persian —
  // which then makes moment().format() render Persian month names elsewhere (e.g. the admin
  // "Register On" dates). Reset here so all displayed dates stay Gregorian; the pickers
  // themselves use locale="en" per-instance and are unaffected.
  moment.locale('en');

  // Dynamic meta title/description for authenticated panels only.
  const path = to.path;
  if (!path.startsWith('/v2/admin/') && !path.startsWith('/v2/employer/') && !path.startsWith('/v2/jobseeker/')) return;

  const panelPrefix = path.startsWith('/v2/admin/') ? 'Admin'
    : path.startsWith('/v2/employer/') ? 'Employer'
    : 'Jobseeker';

  const applyMeta = (attempts) => {
    const crumbItems = Array.from(document.querySelectorAll('.breadcrumb-item'));
    const crumbText = crumbItems
      .map(el => el.innerText.trim())
      .filter(t => t.length > 0)
      .join(' - ');

    // Read the H1 text, excluding icon-font elements whose text content is a
    // ligature name (e.g. "auto_awesome") that would leak into the title.
    const h1 = document.querySelector('h1');
    let h1Text = '';
    if (h1) {
      const clone = h1.cloneNode(true);
      clone.querySelectorAll('.material-icons, .material-icons-outlined').forEach(el => el.remove());
      h1Text = clone.textContent.trim().replace(/\s+/g, ' ');
    }

    // Retry if H1 not yet rendered and we have attempts left
    if (!h1Text && attempts > 0) {
      setTimeout(() => applyMeta(attempts - 1), 150);
      return;
    }

    let titleParts = [];
    if (crumbText) titleParts.push(crumbText);
    if (h1Text) titleParts.push(h1Text);
    if (titleParts.length === 0) return;

    const title = panelPrefix + ' | ' + titleParts.join(' - ') + ' | EL Connect';
    const description = panelPrefix + ' | ' + titleParts.join(' - ');

    document.title = title;

    const setMeta = (selector, attr, value) => {
      let tag = document.querySelector(selector);
      if (!tag) {
        tag = document.createElement('meta');
        const [attrName, attrVal] = attr.split('=');
        tag.setAttribute(attrName, attrVal);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', value);
    };

    setMeta("meta[property='og:title']",       "property=og:title",       title);
    setMeta("meta[name='description']",         "name=description",        description);
    setMeta("meta[property='og:description']",  "property=og:description", description);
    setMeta("meta[property='og:image']",        "property=og:image",       "https://elconnect-preprod.sgp1.cdn.digitaloceanspaces.com/v2/banner_image/elconnect_banner.jpg");
  };

  setTimeout(() => applyMeta(6), 100);
})

export default router
